/* eslint-disable @typescript-eslint/promise-function-async */
import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dealer',
  },
  {
    path: 'dealer',
    loadChildren: () => import('./feature/dealer/dealer.route').then(c => c.routes),
  },
  {
    path: 'customer',
    loadChildren: () => import('./feature/customer/customer.route').then(c => c.routes),
  },
  {
    path: 'm',
    loadComponent: () =>
      import('./feature/customer/components/landing/landing.component').then(
        c => c.LandingComponent
      ),
  },
  {
    path: 'm/:id',
    loadComponent: () =>
      import('./feature/customer/components/landing/landing.component').then(
        c => c.LandingComponent
      ),
  },
  // {
  //   path: 'meet/:id',
  //   loadComponent: () =>
  //     import('./shared/component/meet/meet.component').then((c) => c.MeetComponent),
  // },
  {
    path: 'refresh',
    loadComponent: () =>
      import('./shared/component/refresh/refresh.component').then(c => c.RefreshComponent),
  },
  {
    path: 'self-explore/:model/:variant/:color',
    loadComponent: () =>
      import(
        './feature/two-way-communication/components/three-d-viewer/three-d-viewer.component'
      ).then(c => c.ThreeDViewerComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./core/component/not-found/not-found.component').then(c => c.NotFoundComponent),
  },
];
